import ManagerFactory from "../managers/ManagerFactory";
import AppLogin from "./AppLogin.pages";
import { isAppSession } from "../helper/nativeBridge";

const manager = ManagerFactory.getManager();
function Form(props) {
  if (isAppSession()) return <AppLogin />;
  return manager.getSignupForm();
}

export default Form;
